
import { Button } from "@/components/ui/button";
import { TrendingDown } from "lucide-react";
import { Link } from "react-router-dom";

const DoorDashSavings = () => {
  return (
    <section className="py-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-red-500 to-pink-600"></div>
      <div className="absolute inset-0 opacity-30 bg-gradient-to-br from-transparent via-white/10 to-transparent"></div>
      
      <div className="relative container mx-auto px-4 text-center text-white">
        <div className="flex justify-center mb-6">
          <div className="bg-white/20 backdrop-blur-sm w-16 h-16 rounded-full flex items-center justify-center shadow-xl">
            <TrendingDown className="h-8 w-8 text-white" />
          </div>
        </div>
        
        <h2 className="text-3xl font-bold mb-4 text-white">Stop Overpaying DoorDash Fees!</h2>
        <p className="text-xl opacity-90 mb-6 max-w-2xl mx-auto text-white">
          Skip the high rates! Processing Bros gets you exclusive discounted DoorDash processing rates that aren't available to the public.
        </p>
        
        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 mb-8 max-w-lg mx-auto">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="text-yellow-300 text-xl">⭐</span>
            <span className="font-bold text-yellow-300">EXCLUSIVE PARTNERSHIP</span>
            <span className="text-yellow-300 text-xl">⭐</span>
          </div>
          <p className="text-white font-semibold">Save 5-10% per order vs. going direct</p>
        </div>
        
        <Link to="/doordash-integration">
          <Button variant="warning" size="lg">
            Get Online Ordering →
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default DoorDashSavings;
